import { FundAllocation } from '../index';
import { Api } from 'further-types/allocations';

type HandleUploadAmendmentsParams = {
  amendmentsFile: File | null;
  setUploadErrors: (errors: Array<Api.RowError>) => void;
  uploadFile: any; // Using any for now since the exact type isn't clear from context
  isAllocationPreviewAutoAllocated: boolean;
  formFundAllocations: Array<FundAllocation>;
  setMostRecentAutoAllocationDataSnapshot: (
    data: Array<FundAllocation>,
  ) => void;
  replace: (values: Array<FundAllocation>) => void;
  setIsAutoAllocation: (isAutoAllocation: boolean) => void;
  setIsEditing: (isEditing: boolean) => void;
};

export const handleUploadAmendments = async ({
  amendmentsFile,
  setUploadErrors,
  uploadFile,
  isAllocationPreviewAutoAllocated,
  formFundAllocations,
  setMostRecentAutoAllocationDataSnapshot,
  replace,
  setIsAutoAllocation,
  setIsEditing,
}: HandleUploadAmendmentsParams): Promise<void> => {
  try {
    if (!amendmentsFile) return;
    setUploadErrors([]);

    const formData = new FormData();
    formData.append('uploadExcelFile', amendmentsFile);
    const response = await uploadFile.mutateAsync(formData);

    if (response.data.error?.length) {
      setUploadErrors(response.data.error);
    } else {
      if (isAllocationPreviewAutoAllocated) {
        setMostRecentAutoAllocationDataSnapshot([...formFundAllocations]); // take snapshot so we can go 'back' to AA setup screen ignoring any amendments
      }
      setIsAutoAllocation(false);

      // Update the form values with the new allocation previews using replace
      replace(response.data.allocationPreviews);

      // Enter edit mode so changes can be reviewed before committing
      setIsEditing(true);
    }
  } catch (error) {
    console.error('Upload error:', error);
  }
};
